"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _AdditionalCost = _interopRequireDefault(require("./AdditionalCost"));
var _QuoteLineQuantity = _interopRequireDefault(require("./QuoteLineQuantity"));
var _RfqLinePartDetail = _interopRequireDefault(require("./RfqLinePartDetail"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The QuoteLine model module.
 * @module model/QuoteLine
 * @version 0.0.1
 */
var QuoteLine = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>QuoteLine</code>.
   * @alias module:model/QuoteLine
   */
  function QuoteLine() {
    _classCallCheck(this, QuoteLine);
    QuoteLine.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(QuoteLine, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>QuoteLine</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/QuoteLine} obj Optional instance to populate.
     * @return {module:model/QuoteLine} The populated <code>QuoteLine</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new QuoteLine();
        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient["default"].convertToType(data['id'], 'Number');
        }
        if (data.hasOwnProperty('nsn')) {
          obj['nsn'] = _ApiClient["default"].convertToType(data['nsn'], 'String');
        }
        if (data.hasOwnProperty('description')) {
          obj['description'] = _ApiClient["default"].convertToType(data['description'], 'String');
        }
        if (data.hasOwnProperty('part_number')) {
          obj['part_number'] = _ApiClient["default"].convertToType(data['part_number'], 'String');
        }
        if (data.hasOwnProperty('weight_per_uom')) {
          obj['weight_per_uom'] = _ApiClient["default"].convertToType(data['weight_per_uom'], 'Number');
        }
        if (data.hasOwnProperty('minimum_order_quantity')) {
          obj['minimum_order_quantity'] = _ApiClient["default"].convertToType(data['minimum_order_quantity'], 'Number');
        }
        if (data.hasOwnProperty('part_details')) {
          obj['part_details'] = _ApiClient["default"].convertToType(data['part_details'], [_RfqLinePartDetail["default"]]);
        }
        if (data.hasOwnProperty('coo')) {
          obj['coo'] = _ApiClient["default"].convertToType(data['coo'], 'String');
        }
        if (data.hasOwnProperty('no_quote_classification')) {
          obj['no_quote_classification'] = _ApiClient["default"].convertToType(data['no_quote_classification'], 'String');
        }
        if (data.hasOwnProperty('no_quote_other_reason')) {
          obj['no_quote_other_reason'] = _ApiClient["default"].convertToType(data['no_quote_other_reason'], 'String');
        }
        if (data.hasOwnProperty('will_advise_dt')) {
          obj['will_advise_dt'] = _ApiClient["default"].convertToType(data['will_advise_dt'], 'Date');
        }
        if (data.hasOwnProperty('quantities')) {
          obj['quantities'] = _ApiClient["default"].convertToType(data['quantities'], [_QuoteLineQuantity["default"]]);
        }
        if (data.hasOwnProperty('additional_costs')) {
          obj['additional_costs'] = _ApiClient["default"].convertToType(data['additional_costs'], [_AdditionalCost["default"]]);
        }
      }
      return obj;
    }
  }]);
}();
/**
 * @member {Number} id
 */
QuoteLine.prototype['id'] = undefined;

/**
 * @member {String} nsn
 */
QuoteLine.prototype['nsn'] = undefined;

/**
 * @member {String} description
 */
QuoteLine.prototype['description'] = undefined;

/**
 * @member {String} part_number
 */
QuoteLine.prototype['part_number'] = undefined;

/**
 * @member {Number} weight_per_uom
 */
QuoteLine.prototype['weight_per_uom'] = undefined;

/**
 * @member {Number} minimum_order_quantity
 */
QuoteLine.prototype['minimum_order_quantity'] = undefined;

/**
 * @member {Array.<module:model/RfqLinePartDetail>} part_details
 */
QuoteLine.prototype['part_details'] = undefined;

/**
 * @member {String} coo
 */
QuoteLine.prototype['coo'] = undefined;

/**
 * @member {String} no_quote_classification
 */
QuoteLine.prototype['no_quote_classification'] = undefined;

/**
 * @member {String} no_quote_other_reason
 */
QuoteLine.prototype['no_quote_other_reason'] = undefined;

/**
 * @member {Date} will_advise_dt
 */
QuoteLine.prototype['will_advise_dt'] = undefined;

/**
 * @member {Array.<module:model/QuoteLineQuantity>} quantities
 */
QuoteLine.prototype['quantities'] = undefined;

/**
 * @member {Array.<module:model/AdditionalCost>} additional_costs
 */
QuoteLine.prototype['additional_costs'] = undefined;
var _default = exports["default"] = QuoteLine;